
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3w3bV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bflGB = parcelRequire("bflGB");











var $inPa6 = parcelRequire("inPa6");


var $gz8ZY = parcelRequire("gz8ZY");


var $56QzY = parcelRequire("56QzY");




const $d5cb4540a645a8cc$export$c43964a20c049f81 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { accelerator: accelerator, listener: listener, deprecatedAccelerator: deprecatedAccelerator } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t1;
    if ($[0] !== accelerator || $[1] !== createAnalyticsEvent || $[2] !== isNav4Enabled || $[3] !== listener) {
        t1 = (e)=>{
            const key = typeof accelerator === "string" ? accelerator : accelerator.find((shortcut)=>shortcut.endsWith(e.key)) || accelerator[0];
            if (listener(e) !== false) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "pressed",
                    actionSubject: "keyboardShortcut",
                    source: "globalNavigation",
                    attributes: {
                        key: key,
                        navVersion: isNav4Enabled ? "4" : "3",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = accelerator;
        $[1] = createAnalyticsEvent;
        $[2] = isNav4Enabled;
        $[3] = listener;
        $[4] = t1;
    } else t1 = $[4];
    const listenerWithAnalytics = t1;
    let t2;
    if ($[5] !== accelerator || $[6] !== deprecatedAccelerator || $[7] !== listenerWithAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
            accelerator: accelerator,
            deprecatedAccelerator: deprecatedAccelerator,
            listener: listenerWithAnalytics
        });
        $[5] = accelerator;
        $[6] = deprecatedAccelerator;
        $[7] = listenerWithAnalytics;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ accelerator: accelerator, listener: listener, deprecatedAccelerator: deprecatedAccelerator })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const listenerWithAnalytics = (0, $42omo.useCallback)((e)=>{
        const key = typeof accelerator === 'string' ? accelerator : accelerator.find((shortcut)=>shortcut.endsWith(e.key)) || accelerator[0];
        if (listener(e) !== false) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                source: 'globalNavigation',
                attributes: {
                    key: key,
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    }, [
        accelerator,
        listener,
        createAnalyticsEvent,
        isNav4Enabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        deprecatedAccelerator: deprecatedAccelerator,
        listener: listenerWithAnalytics
    });
});



var $fZAJP = parcelRequire("fZAJP");

const $c8cd6fd98821cd0e$export$90839ff33b4905a0 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator, listener: listener, isAppNavigationShortcut: t1, shortcutType: t2, allowInDialog: t3 } = t0;
    const isAppNavigationShortcut = t1 === undefined ? false : t1;
    const shortcutType = t2 === undefined ? (0, $bflGB.ShortcutType).Confluence : t2;
    const allowInDialog = t3 === undefined ? false : t3;
    const [areGeneralShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!areGeneralShortcutsEnabled) return null;
    let t4;
    if ($[0] !== accelerator || $[1] !== allowInDialog || $[2] !== deprecatedAccelerator || $[3] !== isAppNavigationShortcut || $[4] !== listener || $[5] !== shortcutType) {
        t4 = isAppNavigationShortcut ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5cb4540a645a8cc$export$c43964a20c049f81), {
            accelerator: accelerator,
            deprecatedAccelerator: deprecatedAccelerator,
            listener: listener
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
            accelerator: accelerator,
            deprecatedAccelerator: deprecatedAccelerator,
            listener: listener,
            shortcutType: shortcutType,
            allowInDialog: allowInDialog
        });
        $[0] = accelerator;
        $[1] = allowInDialog;
        $[2] = deprecatedAccelerator;
        $[3] = isAppNavigationShortcut;
        $[4] = listener;
        $[5] = shortcutType;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator, listener: listener, isAppNavigationShortcut: isAppNavigationShortcut = false, shortcutType: shortcutType = (0, $bflGB.ShortcutType).Confluence, allowInDialog: allowInDialog = false })=>{
    const [areGeneralShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!areGeneralShortcutsEnabled) return null;
    return isAppNavigationShortcut ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5cb4540a645a8cc$export$c43964a20c049f81), {
        accelerator: accelerator,
        deprecatedAccelerator: deprecatedAccelerator,
        listener: listener
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        deprecatedAccelerator: deprecatedAccelerator,
        listener: listener,
        shortcutType: shortcutType,
        allowInDialog: allowInDialog
    });
});
module.exports["GeneralShortcutListener"] = $c8cd6fd98821cd0e$export$90839ff33b4905a0;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});


//# sourceMappingURL=GeneralShortcutListener.92b8160e.js.map
